export default __webpack_public_path__ + "static/media/Queen_of_spades.1ebb5715.svg";